import React from "react";
import SettingsNameActiveForm from "../../../../components/SettingsNameActiveForm";
import { TABLE_ORG_SETTINGS_FUNCTIONS_NAME } from "./methods";
import { MODAL_ORG_SETTINGS_FUNCTIONS } from "./index";

const FunctionForm = () => (
  <SettingsNameActiveForm
    modalName={MODAL_ORG_SETTINGS_FUNCTIONS}
    tableName={TABLE_ORG_SETTINGS_FUNCTIONS_NAME}
    apiRoute="job-titles"
    translations={{
      newTitle: "container.org_settings.functions_tab.new_function.form_title",
      editTitle: "container.org_settings.functions_tab.edit_function.form_title",
      nameLabel: "container.org_settings.functions_tab.new_function.function_name",
      activeLabel: "container.org_settings.functions_tab.active"
    }}
  />
);

export default FunctionForm;
